import { 
  CONFIRMED_GET_PATIENT_CURED_DISEASES,
  CONFIRMED_UPDATE_PATIENT_CURED_DISEASES 
} from "./PatientCuredDiseasesTypes";
import {
  getPatientCuredDiseases,
  updatePatientCuredDiseases,
  formatCuredDiseases,
} from "../../services/PatientCuredDiseasesService";
import { showErrorAlert, handleSuccess } from "../../services/ErrorHandlingService";

/**
 * Fetch patient cured diseases from API
 * @param {string|number} patientId - The patient ID
 * @returns {Function} Redux thunk function
 */
export function getPatientCuredDiseasesAction(patientId) {
  return async (dispatch) => {
    try {
      if (!patientId) {
        console.warn("Patient ID not provided for fetching cured diseases");
        dispatch({
          type: CONFIRMED_GET_PATIENT_CURED_DISEASES,
          payload: [],
        });
        return;
      }

      const response = await getPatientCuredDiseases(patientId);

      if (response?.status === 200 && response.data?.status === "success") {
        const curedDiseaseIds = formatCuredDiseases(response.data.data);
        dispatch({
          type: CONFIRMED_GET_PATIENT_CURED_DISEASES,
          payload: curedDiseaseIds,
        });
      } else {
        console.warn("Failed to fetch cured diseases: Server error");
        dispatch({
          type: CONFIRMED_GET_PATIENT_CURED_DISEASES,
          payload: [],
        });
      }
    } catch (error) {
      console.error("API Error fetching cured diseases:", error.response || error);
      // Don't show error alert for this, just log it
      dispatch({
        type: CONFIRMED_GET_PATIENT_CURED_DISEASES,
        payload: [],
      });
    }
  };
}

/**
 * Update patient cured diseases
 * @param {string|number} patientId - The patient ID
 * @param {Array} diseaseIds - Array of disease IDs to mark as cured
 * @returns {Function} Redux thunk function
 */
export function updatePatientCuredDiseasesAction(patientId, diseaseIds = []) {
  return async (dispatch) => {
    try {
      if (!patientId) {
        console.warn("Patient ID not provided for updating cured diseases");
        return;
      }

      const response = await updatePatientCuredDiseases(patientId, diseaseIds);

      if (response?.status === 200 && response.data?.status === "success") {
        // Update the local state with the new cured diseases
        dispatch({
          type: CONFIRMED_UPDATE_PATIENT_CURED_DISEASES,
          payload: diseaseIds.map(String),
        });
        handleSuccess("Disease curation updated successfully");
        console.log("Patient cured diseases updated successfully");
      } else {
        console.warn("Failed to update cured diseases: Server error");
        showErrorAlert("Failed to update disease curation");
      }
    } catch (error) {
      console.error("API Error updating cured diseases:", error.response || error);
      showErrorAlert("Failed to update disease curation: " + (error.response?.data?.message || error.message));
    }
  };
}

